import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { AxiosError } from 'axios';
import { InvoiceResponse } from '@utils/types/organization/invoice.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export const useGetInvoices = () => {
  const { t } = useTranslation();
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const rawSort = (searchParams.sort as string | undefined) || undefined;
  const sort = rawSort && ['date', 'ref'].includes(rawSort) ? rawSort : 'date';

  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const q = (searchParams.q as string | undefined) || undefined;

  const fetchInvoices = async () => {
    const { invoices } = GET_URL_NEW({ offset, limit, q, sort, direction });
    const { data } = await Axios.get<InvoiceResponse>(invoices);
    return data;
  };

  return useQuery<InvoiceResponse, AxiosError<BaseError>>(
    ['invoices', offset, limit, q, sort, direction],
    fetchInvoices,
    {
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      onError: error => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const d = error.response?.data as any;
        const msg =
          d?.error_description ||
          d?.detail ||
          d?.error ||
          d?.message ||
          t('an-error-has-occurred');
        toast.error(String(msg));
      }
    }
  );
};
